var React = require('react');

function ActionMenu (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},[React.createElement("circle",{"cx":"12","cy":"6","r":"2","key":0}),React.createElement("circle",{"cx":"12","cy":"12","r":"2","key":1}),React.createElement("circle",{"cx":"12","cy":"18","r":"2","key":2})]));
}

ActionMenu.defaultProps = {"viewBox":"0 0 24 24","width":"24","height":"24"};

module.exports = ActionMenu;

ActionMenu.default = ActionMenu;
